import {css, FormControlLabel, styled} from '@mui/material';
import {AlertInfo} from 'presentation/components';

const AlertInfoContainer = styled(AlertInfo.Root)`
	& .MuiAlert-message {
		width: 100%;
	}
`;

const StyledCheckbox = styled(FormControlLabel)`
	margin: 0;
	font-size: 0.75rem;
	border-radius: 8px;

	align-items: start;

	${({theme}) => css`
		background-color: ${theme.palette.background.paper};
		color: ${theme.colors.light.text.primary};
	`}

	& .MuiCheckbox-root {
		padding: 0px 8px 0px 0px;
	}
`;

export {AlertInfoContainer, StyledCheckbox};
